/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', () => {
    const trigger = document.querySelector('.warrant-trigger');
const toast = document.getElementById('warrant-toast');

if (trigger && toast) {
  trigger.addEventListener('mouseenter', () => {
    toast.style.display = 'block';
  });

  trigger.addEventListener('mousemove', (e) => {
    // Offset di 15px per non coprire la punta del cursore
    toast.style.left = (e.clientX + 15) + 'px';
    toast.style.top = (e.clientY + 15) + 'px';
  });

  trigger.addEventListener('mouseleave', () => {
    toast.style.display = 'none';
  });
}

/* per prodotto EPAL esenzione iva */
//let url = window.location.href;
//
//if (url && url.includes('pallet-epal-usati')) {
//  let secondPrice = document.querySelector('.secondPriceValue');
//  
//  setTimeout(() => {
//    if (secondPrice) {
//    secondPrice.textContent = " - Esente IVA, ai sensi dell'art. 74, commi 7 e 8 del D.P.R. 633/1972";
//    }
//  }, 10000);
//}


});
